<template>
  <div class="page">
    <!-- 搜索栏头部 -->
    <div class="header-bar">
      <router-link :to="{ name: 'signIn' }"><img class="header-img" src="@/assets/images/daily-attendance@2x.png">
      </router-link>
      <van-search class="header-search" placeholder="" background="#117281" @click="toSearch" />
      <img class="header-qr-icon" :src="$getImgUrl('/wx-app-v2/img/home-qr-icon.png')"
        @click="dialogQr">
    </div>
    <!-- 轮播图 -->
    <van-swipe class="home-swipe flex-auto" :autoplay="3000" indicator-color="#117281" height="150">
      <van-swipe-item v-for="(item, index) in bannerContentList" :key="index" @click="goToWeb(item)">
        <img class="swiper-img" :src="getBannerMobileImageUri(item.mobileImageUri)" />
      </van-swipe-item>
    </van-swipe>
    <!-- 公告 -->
    <div class="home-notice">
      <span class="notice-l">公告发布</span>
      <div class="notice-list">
        <van-swipe class="notice-swipe" :autoplay="3000" :show-indicators="false">
          <van-swipe-item @click="goToWeb(item, 'notice')" v-for="(item, index) of noticeList" :key="index">
            {{ item.noticeTitle }}
          </van-swipe-item>
        </van-swipe>
      </div>
    </div>
    <!-- nav -->
    <div class="home-nav sticky">
      <div class="text-center home-nav-item" v-for="item in homeNavList" :key="item.imgUrl"
        @click="goToWeb(item, 'link')">
        <img class="row-img" :src="$getImgUrl(item.imgUrl)">
        <div>{{ item.name }}</div>
      </div>
    </div>
    <!-- 商品列表 -->
    <div class="sidebar" v-if="isLogin">
      <!-- 列表左侧 -->
      <div class="sidebar-list">
        <!-- 双11秒杀活动 -->
        <div class="sidebar-list-item spike11" v-if="isShowSpike">
        </div>
        <div v-if="isShowSpike" class="sidebar-list-item no-discount" @click="showSpikeList('1')"
          :class="{ 'discount': promotionType === '1' }">
        </div>
        <div v-if="isShowSpike" class="sidebar-list-item no-spike" @click="showSpikeList('2')"
          :class="{ 'spike': promotionType === '2' }">
        </div>

        <div class="sidebar-list-item"
          :class="{ 'active': !categoryActive.categoryId && !tagId.categoryId && !tagId && !promotionType }"
          @click="viewItemList('02', {})">全部</div>
        <div v-for="(items, index) in categoryList" :key="items.categoryName">
          <p class="sidebar-list-item" :class="{ 'active': categoryActive.categoryId == items.categoryId }"
            @click="viewItemList('02', items, index)"> {{ items.categoryName }}
            <span v-show="items.subList && items.subList.length && !items.selected">＞</span>
            <span v-show="items.subList && items.subList.length && items.selected">∨</span>
          </p>
          <transition name="fade">
            <div v-show="items.selected">
              <p class="sidebar-list-item" v-for="item in items.subList" :key="item.categoryCode"
                :class="{ 'active': categoryActive === item }" @click="viewItemList('02', item)"
                style="font-size: 0.3rem;">
                &nbsp;&nbsp;{{ item.categoryName }}</p>
            </div>
          </transition>
        </div>
        <div v-for="(item, index) in tagList" :key="index">
          <div class="sidebar-list-item" :class="{ 'active': tagId === item.tagId }"
          @click="viewItemList('03', item)">{{ item && item.tagName }}</div>
      </div>
        </div>
      <!-- 秒杀活动右侧 -->
      <div class="spike-items" v-if="isShowSpikeList == true">
        <van-list class="van-list" v-model="spikeLoading" :finished="spikeFinished" finished-text="没有更多了"
          @load="spikeOnLoad" :immediate-check="false">
          <div class="spike-right">
            <div class="spike-item" v-for="item in seckillItemList" :key="item.itemId" @click="toGoodsDetail(item)">
              <div class="spike_end" v-if="item.usableStock <= 0 && isShowDiscount == false">
                <div class=" tip-spike">
                </div>
              </div>

              <van-image :src="getSpikeImageUri(item.itemImageUri)" class="spike-item-img"
                radius="0.3rem 0.3rem 0rem 0rem"></van-image>
              <div v-if="promotionType === '1'">
                <div v-if="isShowDiscount" class="tips-discount2"></div>
                <div v-else class="tips-discount"></div>
              </div>
              <div v-else>
                <div v-if="isShowDay" class="countdownDay">
                </div>
                <div v-else class="tips-spike">
                  <span class="countdown" v-if="!isStartSpike">倒计时 <span class="time-box">{{ hour }}</span> : <span class="time-box">{{ minute }}</span> : <span class="time-box">{{ second }}</span></span>
                  <span class="countdown2" v-if="isStartSpike && !endDateSpike"> 秒杀进行中...</span>
                  <span class="countdown2" v-if="isStartSpike && endDateSpike"> 秒杀已结束...</span>
                </div>
              </div>
              <div class="spike-text-line">
                <span>{{ item.itemName }}</span>
              </div>
              <div class="spike-text">
                <div class="spike-item-value1" v-if="promotionType === '1'">
                  <p class="spike-item-basePoint">
                    <span class="spike-item-span">{{ item.promotionPoint }}</span>
                    积分
                  </p>
                  <span class="result-oldintegration"><span>{{ item.exchangePoint }}</span>积分</span>
                </div>
                <div class="spike-item-value" v-else>
                  <p class="spike-item-basePoint"><span>{{ item.pointValue }}</span>积分</p>
                  <div v-if="isStartSpike && item.sellout && item.sellout === '1' && !isLevel && !endDateSpike"
                    class="sellout"></div>
                  <div
                    v-if="isStartSpike && item.attended === '0' && item.sellout && item.sellout === '0' && !isLevel && !endDateSpike"
                    class="grab-buy" @click="grabAndGo(item)"></div>
                  <div v-if="!isStartSpike && !isLevel && !endDateSpike" class="no-open"></div>
                  <div
                    v-if="isStartSpike && item.attended === '1' && item.sellout && item.sellout === '0' && !isLevel && !endDateSpike"
                    class="already-submitted"></div>
                  <div v-if="isStartSpike && endDateSpike && !isLevel" class="spike-end"></div>
                </div>
              </div>
            </div>
          </div>
        </van-list>
      </div>
      <!-- 列表右侧 -->
      <div v-else class="sidebar-items">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad" :immediate-check="false"
          class="van-list">
          <div class="sidebar-right">
            <div class="sidebar-item" v-for="item in itemList" :key="item.itemId" @click="toGoods(item)">

              <div class=" tip_end"
                v-if="item.itemCategory && (item.itemCategory.categoryCode == '501') && (item.clientOrderCount > 0)">
                <div class="tip_end2"></div>
              </div>
              <div v-else>
                <div v-if="item.isNew === 1 && item.isPromotion === 0" class="new-point">
               <img style="width:40px;height:40px;" :src="getImageUrl('/static/item-image-icon/icon_new.png')" alt="">
              </div>
              <div v-if="item.isPromotion === 1 && item.isNew === 0" class="new-point">
               <img style="width:40px;height:40px;"  :src="getImageUrl('/static/item-image-icon/icon_promotion.png')" alt="">
              </div>
              <div v-if="item.isPromotion === 1 && item.isNew === 1" class="new-point">
               <img style="width:40px;height:40px;" :src="getImageUrl('/static/item-image-icon/icon_promotion.png')" alt="">
              </div>
              </div>
              <van-image :src="getBannerMobileImageUri(item.itemImageUri)" class="sidbar-item-img"
                radius="0.3rem 0.3rem 0rem 0rem"></van-image>
              <div class="sidbar-text">
                <div class="sidbar-text-line">
                  <!-- <van-tag color="pink" text-color="#e20015" v-if="item.isPromotion === 1">促</van-tag> -->
                  <span>{{ item.itemName }}</span>
                </div>
                <div class="sidbar-item-value">
                  <p class="sidbar-item-basePoint" v-if="item.isPromotion !== 1"><span>{{ item.basePoint }}</span>积分</p>
                  <p class="sidbar-item-basePoint" v-if="item.isPromotion === 1"><span>{{ item.promotionPoint
                  }}</span>积分
                  </p>
                  <p class="sidbar-item-usableStock"
                    v-if="!item.itemCategory || (item.itemCategory.categoryCode !== '501')">库存: {{ item.usableStock
                    }}</p>
                  <p class="sidbar-item-usableStock"
                    v-if="item.itemCategory && (item.itemCategory.categoryCode == '501')">兑换数量: {{
                        item.itemOrderCount
                    }}</p>
                </div>
              </div>
            </div>
          </div>
        </van-list>
      </div>
    </div>
    <div v-else class="no-login">
      <router-link to="/login2">
        <van-button type="primary">登录查看更多</van-button>
      </router-link>
    </div>

    <!-- 底部栏 -->
    <tabbar :active="0" @showWxDialog="showWxDialog"></tabbar>
    <!-- Qr -->
    <!-- <van-dialog v-model="dialogQrOption.dialogQrShow" :title="dialogQrOption.title" :message="dialogQrOption.message"
      show-cancel-button :confirmButtonColor="dialogQrOption.confirmButtonColor"
      :confirmButtonText="dialogQrOption.confirmButtonText" :cancelButtonText="dialogQrOption.cancelButtonText"
      @confirm="dialogQr">
    </van-dialog> -->

    <van-dialog v-model="wxDialog" title="提示" @confirm="wxDialog = false"
      :confirmButtonColor="dialogQrOption.confirmButtonColor" confirmButtonText="确定">
      <div class="wx_dialog_message">扫码获取积分渠道将于下月开通，目前扫码请微信搜索并关注“<span
          class="font_weight600">extra易加网</span>”公众号，点击“<span class="font_weight600">扫码积分</span>”</div>
      <div class="qrcode"><img src="../../assets/images/mid-autumn-qr-code.jpg" alt="" /></div>
    </van-dialog>

    <van-dialog v-model="wxQrDialog" title="提示" @confirm="wxQrDialog = false"
      :confirmButtonColor="'#117281'" confirmButtonText="确定">
      <div class="wx_dialog_message">目前该防伪功能仅支持微信扫码，请微信搜索并关注“<span
          class="font_weight600">extra易加网</span>”公众号后重试。</div>
      <div class="qrcode"><img src="../../assets/images/mid-autumn-qr-code.jpg" alt="" /></div>
    </van-dialog>
  </div>

</template>

<script>
import homeApi from '@/api/home'
import sortApi from '@/api/sort'
import Tabbar from '../../components/tabbar.vue'
import { mapState } from 'vuex'
import { userUtils } from '@/utils/auth'
import { commonUtils } from '@/utils/common'
export default {
  name: 'home-main',
  components: {
    Tabbar
  },
  data () {
    return {
      bannerContentList: [],
      categoryList: [],
      seckillItemList: [],
      keyword: '',
      categoryActive: {},
      itemList: [],
      tagList: [],
      loading: false,
      spikeLoading: false,
      finished: false,
      spikeFinished: false,
      isShowSpikeList: false,
      needLaunch: true,
      page: 1,
      spikePage: 1,
      discountPage: 1,
      dialogQrOption: {
        dialogQrShow: false
        // title: '系统提示',
        // message: '是否需要扫码验证产品真伪？',
        // confirmButtonColor: '#117281',
        // confirmButtonText: '是',
        // cancelButtonText: '否'
      },
      noticeList: [],
      homeNavList: [{
        name: '配件查询',
        imgUrl: '/img/home/parts-check@2x.png',
        link: ''
      }, {
        name: '博世学堂',
        imgUrl: '/img/home/bosch-school@2x.png',
        link: '',
        routerName: 'course-category-list'
      }, {
        name: '综合服务',
        imgUrl: '/img/home/seckill@2x.png',
        link: ''
      }, {
        name: '每日签到',
        imgUrl: '/img/home/daily-attendance@2x.png',
        link: '',
        routerName: 'signIn'
      }
      // {
      //   name: 'BSS签约',
      //   imgUrl: '/img/home/bss-client.png',
      //   link: '',
      //   routerName: 'signUp'
      // }
      ],
      promotion: {},
      advertisement: [],
      isLogin: false,
      isWxEnv: true,
      wxDialog: false,
      wxQrDialog: false,
      tagId: '',
      promotionType: '',
      startDate: 0,
      endDate: 0,
      minute: '00',
      second: '00',
      isLevel: false,
      hour: 0,
      day: 1,
      displayTime: 0,
      isShowSpike: false,
      isShowDay: false,
      isShowDiscount: false,
      isStartSpike: false,
      isCloseActivite: false,
      timeOut: '',
      usableStock: '',
      isChannelPrefix: true,
      channelPrefix: '',
      pageSize: 10,
      endDateSpike: false
    }
  },
  computed: {
    ...mapState({
      ecatSiteUrl: state => state.base.ApiEndpoint.ecatSiteUrl,
      tssUrl: state => state.base.ApiEndpoint.tssUrl,
      qrSiteUrl: state => state.base.ApiEndpoint.qrSiteUrl
    })

  },
  created () {
    if (this.$route.query.cards) {
      this.$bus.emit('lowerRight', 1)
    }
    this.homeNavList[0].link = this.ecatSiteUrl
    this.homeNavList[2].link = this.tssUrl

    this.isWxEnv = commonUtils.isWxEnv()
    commonUtils.configWxJsSdk().catch(error => {
      this.$emit('error', { errorMsg: error })
    })
    this.userRole()
    commonUtils.reportViewTrace()
  },
  mounted () {
    const u = navigator.userAgent
    const isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
    if (isIOS && location.href.indexOf('#reloaded') === -1) {
      location.href = location.href + '#reloaded'
      location.reload()
    }
    let level = JSON.parse(localStorage.getItem('userInfo')).clientInfo.clientUserDTO.userRole || ''
    this.level = level
    if (this.level === '03') {
      this.isLevel = true
    } else {
      this.isLevel = false
    }
  },
  activated () {
    if (localStorage.getItem('lastLoginTime')) {
      let lastLoginTime = localStorage.getItem('lastLoginTime')
      this.$dialog.alert({ message: `您上次登录成功时间${lastLoginTime},欢迎再次访问`, confirmButtonText: '好的' })
      localStorage.removeItem('lastLoginTime')
    }
    this.clientInfo = userUtils.getClientInfo() || ''
    let channelPrefix = (this.clientInfo.channelCode && this.clientInfo.channelCode.substring(0, 4)) || ''
    let channelPrefix2 = (this.clientInfo.channelCode && this.clientInfo.channelCode.substring(0, 2)) || ''
    this.isChannelPrefix = channelPrefix2 === '11' || channelPrefix2 === '12' || (channelPrefix2 === '13' && (channelPrefix !== '1350' && channelPrefix !== '1340' && channelPrefix !== '1330'))
    const beginTime = new Date('2023/06/16 00:00:00').getTime()
    const endTime = new Date('2023/06/30 23:59:59').getTime()
    const curDate = new Date().getTime()
    const val = curDate <= endTime && curDate >= beginTime
    if (val && this.isChannelPrefix) {
      this.showSpikeList('1')
      this.isShowSpike = true
      this.in11Scope()
      if (this.$route.params.itemId) {
        this.querySpikeList()
      }
    }
    let userLocal = userUtils.getUserLocal() || null
    let tokenExpireTime = (userLocal && userLocal.tokenExpireTime) || 0
    if (userLocal && tokenExpireTime) {
      let time = new Date().getTime()
      if (time < tokenExpireTime) {
        if (!this.categoryList.length) {
          this.init()
          this.isLogin = true
        } else {
          if (this.tagId) {
            this.viewItemList('03', this.tagList)
          } else {
            this.viewItemList('02', this.categoryActive)
          }
        }
        if (this.$route.query.categoryId) {
          this.categoryActive.categoryId = this.$route.query.categoryId
          this.queryItemCategoryList()
        }
      } else {
        this.categoryList = []
        this.itemList = []
        this.isLogin = false
      }
    } else {
      this.categoryList = []
      this.itemList = []
      this.isLogin = false
    }
    this.queryPublicContent()
  },
  methods: {
    init () {
      this.queryItemCategoryList()
      this.queryPublicNoticeList()
      this.queryItemTagShowInCategoryList()
      this.userRole()
    },
    userRole () {
      let level = JSON.parse(localStorage.getItem('userInfo')).clientInfo.clientUserDTO.userRole || ''
      this.level = level
      if (this.level === '03') {
        this.isLevel = true
      } else {
        this.isLevel = false
      }
    },
    beforeDestroy () {
      if (this.timeOut) { // 如果定时器在运行则关闭
        clearInterval(this.timer)
      }
    },
    in11Scope () {
      if (!this.isChannelPrefix) {
        this.promotionType = ''
        this.isShowSpike = false
      }
      const beginTime = new Date('2023/06/16 00:00:00').getTime()
      const endTime = new Date('2023/06/30 23:59:59').getTime()
      const curDate = new Date().getTime()
      const val = curDate <= endTime && curDate >= beginTime
      const end = curDate > endTime
      if (end) {
        this.promotionType = ''
        this.isShowSpike = false
        this.viewItemList('02', {})
        clearTimeout(this.timeOut)
      } else {
        if (val && !this.promotionType && this.needLaunch) {
          this.promotionType = '1'
          this.isShowSpike = true
          this.showSpikeList('1')
          this.needLaunch = false
          this.timeOut = setTimeout(() => {
            this.in11Scope()
          }, 1000)
        } else {
          this.timeOut = setTimeout(() => {
            this.in11Scope()
          }, 1000)
        }
      }
    },
    // 获取banner图
    queryPublicContent () {
      // contentType;01主页banner;02主页促销位;03广告位;04首页弹窗
      let params = {
        useScope: 'weChat'
      }
      homeApi.queryPublicContent(params).then(res => {
        if (res.data.resultCode === '0') {
          const { contentList } = res.data.resultData
          this.bannerContentList = []
          for (let item in contentList || []) {
            if (contentList[item].useScope === 'app' || contentList[item].useScope === 'weChat' || contentList[item].useScope === 'both') {
              if (contentList[item].contentType === '01') {
                this.bannerContentList.push(contentList[item])
              }
            }
          }
        }
      })
    },
    getBannerMobileImageUri (mobileImageUri) {
      return process.env.VUE_APP_FILE_SERVER + mobileImageUri
    },
    getSpikeImageUri (itemImageUri) {
      return process.env.VUE_APP_FILE_SERVER + itemImageUri
    },
    // 查询全部分类
    queryItemCategoryList () {
      sortApi.queryItemCategoryList().then(res => {
        if (res.data.resultCode === '0') {
          const { categoryList } = res.data.resultData
          this.categoryList = categoryList || []
          if (this.categoryActive.categoryId) {
            this.viewItemList('02', { categoryId: this.categoryActive.categoryId })
          } else {
            if (this.isShowSpike) {
              this.showSpikeList('1')
            } else {
              this.viewItemList('02', {})
            }
          }
          this.categoryList.forEach(item => {
            if (item.subList && item.subList.length) {
              item.selected = false
            }
          })
        }
      })
    },
    queryItemTagShowInCategoryList () {
      sortApi.queryItemTagShowInCategoryList().then(res => {
        if (res.data.resultCode === '0') {
          this.tagList = res.data.resultData.tagList || []
        }
      })
    },
    queryPublicNoticeList () {
      homeApi.queryPublicNoticeList().then(res => {
        if (res.data.resultCode === '0') {
          this.noticeList = res.data.resultData.noticeList
        }
      })
    },
    // 选择分类
    viewItemList (type, data, index) {
      this.promotionType = ''
      this.isShowSpikeList = false
      // type 01 搜索关键词，02 选择分类,03 促销活动
      if (data.subList && data.subList.length) {
        this.categoryList[index].selected = !this.categoryList[index].selected
        this.categoryList = Object.assign([], this.categoryList)
        this.categoryActive = {}
        this.tagId = ''
        return
      }
      this.$toast.loading({
        duration: 0,
        message: '加载中...'
      })
      if (type === '02') {
        this.categoryActive = data
        this.tagId = ''
      }
      if (type === '03') {
        this.categoryActive = {}
        this.tagId = data.tagId
      }
      this.itemList = []
      this.page = 1
      this.finished = true
      let dataParams = {
        keyword: this.keyword,
        pointFrom: '',
        pointTo: '',
        page: this.page,
        pageSize: this.pageSize,
        categoryId: this.categoryActive.categoryId,
        tagId: this.tagId
      }
      sortApi.queryItemList(dataParams).then(res => {
        if (res.data.resultCode === '0') {
          const { itemList, pageInfo } = res.data.resultData
          this.itemList = itemList
          this.finished = Boolean(pageInfo.totalPages < 2)
          this.$toast.clear()
        }
      }).catch(() => { this.$toast.clear() })
    },
    // 秒杀活动详情
    querySpikeList () {
      this.spikePage = 1
      this.$toast.loading({
        duration: 0,
        message: '加载中...',
        forbidClick: true
      })
      let params = {
        activityCode: 'SECKILL20230622',
        page: this.spikePage,
        pageSize: this.pageSize
      }
      sortApi.querySpikeList(params).then(res => {
        if (res.data.resultCode === '0') {
          this.spikeItemList = res.data.resultData.seckillItemList || []
          this.seckillItemList = this.spikeItemList
          this.startDate = res.data.resultData.activityInfo.startDate
          this.endDate = res.data.resultData.activityInfo.endDate
          this.displayTime = res.data.resultData.displayTime
          this.spikePage = res.data.resultData.pageInfo.curPage
          this.spikeFinished = Boolean(res.data.resultData.pageInfo.totalPages < 2)
          const closeDate = new Date().getTime()
          if (this.startDate - closeDate <= 0) {
            this.isStartSpike = true
          }
          if (this.endDate <= closeDate) {
            this.endDateSpike = true
          }
          this.countdown()
          this.$toast.clear()
        }
      }).catch(() => { this.$toast.clear() })
    },
    // 折扣活动详情
    queryDiscountList () {
      this.discountPage = 1
      this.$toast.loading({
        duration: 0,
        message: '加载中...',
        forbidClick: true
      })
      let params = {
        activityCode: '20230618',
        page: this.discountPage,
        pageSize: this.pageSize
      }
      sortApi.queryDiscountList(params).then(res => {
        if (res.data.resultCode === '0') {
          this.discountItemList = res.data.resultData.itemList || []
          this.seckillItemList = this.discountItemList
          this.disStartDate = res.data.resultData.activityInfo.startDate
          this.discountPage = res.data.resultData.pageInfo.curPage
          this.spikeFinished = Boolean(res.data.resultData.pageInfo.totalPages < 2)
          const nowDate = Date.parse(new Date())
          if (this.disStartDate - nowDate >= 0) {
            this.isShowDiscount = true
          }
          this.$toast.clear()
        }
      }).catch(() => {
        this.$toast.clear()
      })
    },
    // 打开全部秒杀商品
    showSpikeList (type) {
      this.tagId = ''
      this.categoryActive = {}
      if (type === '1') {
        this.promotionType = '1'
        this.queryDiscountList()
        this.isShowSpikeList = true
      } else {
        this.promotionType = '2'
        this.querySpikeList()
        this.isShowSpikeList = true
      }
    },
    // 秒杀倒计时
    countdown () {
      const end = this.startDate
      const now = Date.parse(new Date())
      const msec = end - now
      if (msec < 0) return
      let day = parseInt(msec / 1000 / 60 / 60 / 24)
      let hour = parseInt(msec / 1000 / 60 / 60 % 24)
      let minute = parseInt(msec / 1000 / 60 % 60)
      let second = parseInt(msec / 1000 % 60)
      this.day = day
      this.hour = hour > 9 ? hour : '0' + hour
      this.minute = minute > 9 ? minute : '0' + minute
      this.second = second > 9 ? second : '0' + second
      const that = this
      if (this.day >= 1) {
        this.isShowDay = true
      } else {
        this.isShowDay = false
      }
      if (minute >= 0 && second >= 0) {
        // 倒计时结束关闭订单
        if (minute === 0 && second === 0) {
          return
        }
        setTimeout(function () {
          that.countdown()
        }, 1000)
      }
    },
    // 秒杀抢购

    grabAndGo (item) {
      this.$router.push({ name: 'spikeAddress', query: { itemId: item.itemId } })
    },

    // 底部刷新
    onLoad () {
      const page = this.page + 1
      const keyword = this.keyword
      const categoryId = this.categoryActive.categoryId
      let dataParams = {
        keyword: keyword,
        pointFrom: '',
        pointTo: '',
        page: page,
        pageSize: 10,
        categoryId: categoryId,
        tagId: ''
      }
      sortApi.queryItemList(dataParams).then(res => {
        this.loading = false
        if (res.data.resultCode === '0') {
          const { itemList } = res.data.resultData
          this.itemList = this.itemList.concat(itemList)
          this.page++
          if (!itemList.length) {
            this.finished = true
          }
        }
      })
    },
    // 折扣秒杀底部刷新
    spikeOnLoad () {
      if (this.promotionType === '1') {
        const page = this.discountPage + 1
        let dataParams = {
          activityCode: '20230618',
          page: page,
          pageSize: this.pageSize
        }
        sortApi.queryDiscountList(dataParams).then(res => {
          if (res.data.resultCode === '0') {
            const { itemList } = res.data.resultData
            this.seckillItemList = this.seckillItemList.concat(itemList)
            this.spikeLoading = false
            this.discountPage++
            if (!itemList.length) {
              this.spikeFinished = true
            }
          }
        })
      } else if (this.promotionType === '2') {
        const page = this.spikePage + 1
        let dataParams = {
          activityCode: 'SECKILL20230622',
          page: page,
          pageSize: this.pageSize
        }
        sortApi.querySpikeList(dataParams).then(res => {
          if (res.data.resultCode === '0') {
            const { seckillItemList } = res.data.resultData
            this.seckillItemList = this.seckillItemList.concat(seckillItemList)
            this.spikeLoading = false
            this.spikePage++
            if (!seckillItemList.length) {
              this.spikeFinished = true
            }
          }
        })
      }
    },
    dialogQr () {
      // this.dialogQrOption.dialogQrShow = false
      this.isWxEnv = commonUtils.isWxEnv()
      if (!this.isWxEnv) {
        this.wxQrDialog = true
      } else {
        this.$wx.scanQRCode({
          needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
          scanType: ['barCode', 'qrCode', 'datamatrix', 'pdf417'], // 可以指定扫二维码还是一维码，默认二者都有
          success: res => {
            let valueArray = res.resultStr.split('/')
            let codeValue = valueArray[valueArray.length - 1]
            // if (codeValue.length !== 36 && codeValue.length > 18) {
            //   codeValue = codeValue.substring(codeValue.length - 18)
            // }
            window.location.href = this.qrSiteUrl + codeValue
          },
          fail: res => {
            this.$toast('调用扫码功能异常')
            console.log('fail', res)
          },
          cancel: function () {
            console.log('scan cancel')
          }
        })
      }
    },
    // 折扣跳转详情
    toGoodsDetail (item) {
      if (item.itemCategory && this.isShowDiscount === false && item.usableStock > 0) {
        if (item.itemCategory.categoryCode !== '501') {
          this.$router.push({
            name: 'goods-detail',
            query: {
              itemId: item.itemId
            }
          })
        } else {
          this.$router.push({
            name: 'knowledge-goods',
            query: {
              itemId: item.itemId
            }
          })
        }
      }
    },
    toGoods (item) {
      if (item.itemCategory && item.itemCategory.categoryCode === '501') {
        this.$router.push({
          name: 'knowledge-goods',
          query: {
            itemId: item.itemId
          }
        })
      } else {
        this.$router.push({
          name: 'goods-detail',
          query: {
            itemId: item.itemId
          }
        })
      }
    },
    toSearch () {
      this.$store.commit('search_m_setKeywordData', '')
      this.$router.push({
        path: '/search'
      })
    },
    goToWeb (item, mode) {
      if (mode === 'notice') {
        this.$router.push({ name: 'notice', params: { id: item.noticeId } })
      } else if (mode === 'link') {
        item.routerName ? this.$router.push({ name: item.routerName }) : window.location.href = item.link
      } else {
        window.location.href = item.targetUrl
      }
    },
    getImageUrl (imageUri) {
      return commonUtils.getImageUrl(imageUri)
    },
    showWxDialog () {
      this.wxDialog = true
    }
  }
}
</script>

<style scoped lang="less">
@keyframes scaleDraw {
  /*定义关键帧、scaleDrew是需要绑定到选择器的关键帧名称*/

  0% {
    transform: scale(1);
    /*开始为原始大小*/
  }

  25% {
    transform: scale(1.1);
    /*放大1.1倍*/
  }

  50% {
    transform: scale(1);
  }

  75% {
    transform: scale(1.1);
  }
}

.header-bar {
  display: flex;
  background-color: #117281;
  align-items: center;
  padding: 0 0.35rem;
  width: 100%;
  box-sizing: border-box;
  z-index: 9;
  // height: 100%;
  position: fixed;
  top: 0px;
  left: 0px;

  .header-search {
    flex: 1;
    height: 1.25rem;
  }

  .header-img {
    width: 0.85rem;
    height: 0.85rem;
  }

  .header-qr-icon {
    width: 0.85rem;
    height: 0.85rem;
  }
}

.sidebar {
  display: flex;
  padding-bottom: 1.5rem;

  .sidebar-list {
    width: 2.5rem;
    height: calc(100vh - 3.5rem - 30px);
    overflow: scroll;
    flex-shrink: 0;

    .sidebar-list-item {
      font-size: 0.3rem;
      padding: 0.35rem 0.1rem;
      text-align: center;
    }

    // 双11秒杀活动
    .spike11 {
      background-image: url("../../assets/images/activity/618/618.png");
      background-size: 76px 16px;
      background-repeat: no-repeat;
      background-position: center;
      margin-top: 10px;
    }

    .no-spike {
      background-image: url("../../assets/images/activity/618/no-spike.png");
      background-size: 30px 15px;
      background-repeat: no-repeat;
      background-position: center;
    }

    .spike {
      background-image: url("../../assets/images/activity/618/spike.png");
      background-size: 55px 26px;
      background-repeat: no-repeat;
      background-position: center;
    }

    .no-discount {
      background-image: url("../../assets/images/activity/618/no-discount.png");
      background-size: 30px 15px;
      background-repeat: no-repeat;
      background-position: center;
    }

    .discount {
      background-image: url("../../assets/images/activity/618/discount.png");
      background-size: 55px 26px;
      background-repeat: no-repeat;
      background-position: center;
    }

    .active {
      color: #e20015;
      font-size: 0.4rem;
      font-weight: bold;
    }
  }

  .sidebar-items {
    overflow: scroll;
    width: 100%;
    height: calc(100vh - 3.5rem - 30px);

    .sidebar-right {
      display: flex;
      flex-wrap: wrap;
    }

    .sidebar-item {
      border-radius: 0.3rem;
      width: 45%;
      background-color: white;
      margin: 2%;
      font-size: 0.25rem;
      position: relative;
      .new-point{
        position: absolute;
        top: 0;
        right: -10px;
        width: 50px;
        height: 50px;
        z-index: 1;
      }

      .tip_end {
        // width:5.7rem ;
        // height: .9rem;
        // background-color: #117281;
        // color: #fff !important;
        position: absolute;
        z-index: 1;
        top: 0;
        left: 0;
        text-align: center;
        border-radius: 1.6px;
        font-size: .2rem;

        .tip_end2 {
          background: url(../../assets/images/really.png);
          //  display: inline-block;
          width: 1rem;
          height: 1rem;
          background-size: contain;
          margin-left: 2.37rem;
        }

      }

      .sidbar-item-img {
        width: 100%;
        height: 3.5rem;
      }

      .sidbar-text {
        padding: 0.15rem;

        .sidbar-text-line {
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
        }
      }

      .sidbar-item-value {
        display: flex;
        align-items: flex-end;
        justify-content: space-between;
        flex-wrap: wrap;
        height: 0.5rem;

        .sidbar-item-basePoint {
          color: #e20015;

          span {
            font-size: 0.4rem;
          }
        }

        .sidbar-item-usableStock {
          color: gray;
          font-size: 0.2rem;
        }
      }
    }
  }

  // 双十一活动样式
  .spike-items {
    overflow: scroll;
    width: 100%;
    height: calc(100vh - 3.5rem - 30px);

    .spike-right {
      display: flex;
      flex-wrap: wrap;
    }

    .spike-item {
      border-radius: 0.3rem;
      width: 45%;
      height: 195px;
      background-color: white;
      margin: 2%;
      font-size: 0.25rem;
      position: relative;

      .spike_end {
        position: absolute;
        z-index: 1;
        top: 0;
        left: 0;
        text-align: center;
        border-radius: 1.6px;
        font-size: .2rem;

        .tip-spike {
          background: url(../../assets/images/activity/618/sellout.png);
          width: 1rem;
          height: 1rem;
          background-size: contain;
          margin-left: 2.37rem;
        }

      }

      .spike-item-img {
        width: 100%;
        height: 3.5rem;
      }

      .tips-discount {
        position: absolute;
        top: 97px;
        left: 5px;
        height: 35px;
        width: 33px;
        background-image: url("../../assets/images/activity/618/discount-tip.png");
        background-size: 33px 35px;
        background-repeat: no-repeat;
      }

      .tips-discount2 {
        position: absolute;
        top: 105px;
        height: 25px;
        width: 100%;
        background-image: url("../../assets/images/activity/618/discount-tips.png");
        background-size: 127px 25px;
        background-repeat: no-repeat;
      }

      .countdownDay {
        position: absolute;
        top: 105px;
        height: 25px;
        width: 100%;
        background-image: url("../../assets/images/activity/618/spike-tips-22.png");
        background-size: 127px 25px;
        background-repeat: no-repeat;
      }

      .tips-spike {
        position: absolute;
        top: 101px;
        height: 33px;
        width: 100%;
        background-image: url("../../assets/images/activity/618/spike-tip.png");
        background-size: 127px 33px;
        color: #fff;
        background-repeat: no-repeat;

        .countdown {
          font-weight:normal;
          font-size: 9px;
          display: block;
          margin-right: 5px;
          text-align: right;
          height: 33px;
          line-height: 36px;
          .time-box{
            background-color: #fff;
            padding: 1px 2px;
            border-radius: 2px;
            color: #3D8898;
            font-size: 8px;
          }
        }

        .countdown2 {
          font-weight: normal;
          font-size: 10px;
          display: block;
          margin-right: 15px;
          text-align: right;
          height: 33px;
          line-height: 36px;
        }

      }

      .spike-text-line {
        margin-top: 5px;
        font-size: 12px;
        font-weight: 600;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        margin-left: 6px;
      }

      .spike-text {
        padding: 0.15rem;
      }

      .spike-item-value1 {
        display: flex;
        align-items: flex-end;
        justify-content: left;
        flex-wrap: wrap;
        height: 0.5rem;

        .spike-item-span {
          color: #e20015;
          font-weight: 600;
          font-size: 14px;
        }
        .spike-item-basePoint {
          color: #e20015;
          font-weight: 600;
          font-size: 11px;

        }
        .result-oldintegration {
          color: #606060;
          text-decoration: line-through;
          font-weight: 300;
          font-size: 11px;
        }
      }
      .spike-item-value {
        display: flex;
        align-items: flex-end;
        justify-content: space-between;
        flex-wrap: wrap;
        height: 0.5rem;

        .grab-buy {
          animation: scaleDraw 3s ease-in-out infinite;
          width: 52px;
          height: 18px;
          background-image: url("../../assets/images/activity/618/immediate-seconds.png");
          background-size: 52px 18px;
          background-repeat: no-repeat;
        }

        .spike-end {
          width: 52px;
          height: 18px;
          background-image: url("../../assets/images/spike-end.png");
          background-size: 52px 18px;
          background-repeat: no-repeat;
        }

        .sellout {
          width: 52px;
          height: 18px;
          background-image: url("../../assets/images/activity/618/no-shops.png");
          background-size: 52px 18px;
          background-repeat: no-repeat;
        }

        .no-open {
          width: 52px;
          height: 18px;
          background-image: url("../../assets/images/activity/618/start-soon.png");
          background-size: 52px 18px;
          background-repeat: no-repeat;
        }

        .already-submitted {
          width: 52px;
          height: 18px;
          background-image: url("../../assets/images/activity/618/already-second.png");
          background-size: 52px 18px;
          background-repeat: no-repeat;
        }

        .spike-item-basePoint {
          color: #e20015;
          font-weight: 600;
          font-size: 14px;

        }
      }
    }
  }

}

.van-list {
  height: 150px;
  width: 100%;
}

.flex-1 {
  flex: 1 1 0%;
}

.flex-auto {
  flex: 1 1 auto;
}

.home-swipe {
  flex-shrink: 0;
  height: 3.5rem;
}

.home-notice {
  background-color: #fff;
  padding: 8px 0;
  // margin-bottom: 10px;
  display: flex;

  .notice-l {
    writing-mode: horizontal-tb;
    display: block;
    width: 80px;
    height: 0.58rem;
    line-height: 22px;
    text-align: center;
    border-right: 1px solid #f1f1f1;
    color: #e20015;
    font-size: 18px;
    font-style: italic;
    font-weight: bold;
    margin-left: 10px;
  }

  .van-swipe {
    margin-left: 10px;
    width: calc(100vw - 120px);
    line-height: 22px;
  }

  .van-swipe-item {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.home-nav {
  background-color: #fff;
  padding: 0.2rem 0.4rem;
  display: flex;
  font-size: 0.3rem;
  justify-content: space-between;

  .home-nav-item {
    margin: 0rem 0.2rem;

    .row-img {
      width: 1.2rem;
      height: 1.2rem;
    }
  }
}

.no-login {
  position: relative;
  background: linear-gradient(to bottom, #f0f0f0, #e7e7e7, #f0f0f0);
  // opacity: 70%;
  min-height: 400px;
  height: 400px;

  button {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}

.qrcode {
  img {
    width: 120px;
    height: 120px;
  }

  text-align: center;
}

.wx_dialog_message {
  margin: 15px 25px;
  line-height: 30px;
}

.font_weight600 {
  font-weight: 600;
}

.sticky {
  position: sticky !important;
  position: -webkit-sticky !important;
  top: 50px !important;
  left: 0 !important;
  z-index: 99;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity .15s
}

.fade-enter,
.fade-leave-to {
  opacity: 0
}
</style>
